package nacholab.supplies

import nacholab.supplies.domain.Supply
import nacholab.supplies.domain.ShoppingListItem

data class MainState(
    val lang: String,
    val supplies: List<Supply>,
    val suppliesByMarketLocation: Map<String, List<Supply>>,
    val suppliesByHomeLocation: Map<String, List<Supply>>,
    val shoppingList: Map<String, List<ShoppingListItem>>,
    val editingConsumable: Supply?,
    val marketLocations: List<String>,
    val homeLocations: List<String>,
    val sort: SortMode,
    val exportDBToFile: String?,
    val isAuthenticated: Boolean,
    val isAuthenticationLoading: Boolean,
    val waitingForCodeVerification: Boolean,
    val authenticationError: String?,
    val suppliesLoading: Boolean,
    val suppliesLoadingError: String?,
    val currentAuthenticatingEmail: String?,

    val editingMode: Boolean,
    val savingEdit: Boolean,
    val changesMade: Boolean,
    val nameFields: Map<String, String>,
    val currentStockFields: Map<String, Int>,
    val requiredStockFields: Map<String, Int>,
    val homeFields: Map<String, String>,
    val marketFields: Map<String, String>,

    val changesMadeFields: Map<String, Boolean>,

    val showAddSupplyDialog: Boolean,
    val addSupplyName: String,
    val addSupplyRequiredStock: Int,
    val addSupplyCurrentStock: Int,
    val addSupplyLocationAtHome: String,
    val addSupplyLocationAtMarket: String,
){
    companion object{
        val DEFAULT = MainState(
            lang = "en",
            supplies = listOf(),
            suppliesByMarketLocation = mapOf(),
            suppliesByHomeLocation = mapOf(),
            shoppingList = mapOf(),
            editingConsumable = null,
            marketLocations = listOf(),
            homeLocations = listOf(),
            editingMode = false,
            sort = SortMode.NAME,
            savingEdit = false,
            exportDBToFile = null,
            isAuthenticated = false,
            isAuthenticationLoading = false,
            waitingForCodeVerification = false,
            authenticationError = null,
            suppliesLoading = false,
            suppliesLoadingError = null,
            currentAuthenticatingEmail = null,
            nameFields = mapOf(),
            currentStockFields = mapOf(),
            requiredStockFields = mapOf(),
            homeFields = mapOf(),
            marketFields = mapOf(),
            changesMade = false,
            changesMadeFields = mapOf(),
            showAddSupplyDialog = false,
            addSupplyName = "",
            addSupplyRequiredStock = 0,
            addSupplyCurrentStock = 0,
            addSupplyLocationAtHome = "",
            addSupplyLocationAtMarket = ""
        )
    }
}

enum class SortMode {
    NAME, MARKET_LOCATION, HOME_LOCATION
}